import React from "react";
import { motion } from "framer-motion";

const Section = ({ title, children }) => (
  <section className="mb-8">
    <h2 className="text-xl font-bold text-gray-900 mb-3">{title}</h2>
    <div className="text-gray-600 leading-relaxed space-y-3 text-sm">{children}</div>
  </section>
);

const TermsPage = () => (
  <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
      <div className="mb-10">
        <p className="text-brand-600 text-sm font-semibold uppercase tracking-wider mb-2">Legal</p>
        <h1 className="text-4xl font-black text-gray-900 mb-3">Terms & Conditions</h1>
        <p className="text-gray-500">Last updated: January 1, 2025</p>
      </div>

      <div className="card p-8 md:p-12">
        <Section title="1. Acceptance of Terms">
          <p>By accessing or using the StoreOnline website at storeonline.online (the "Site"), placing an order, or using any of our services, you agree to be bound by these Terms and Conditions. If you do not agree to all of these terms, please do not use our Site.</p>
          <p>We reserve the right to modify these Terms at any time. Your continued use of the Site after any modifications constitutes your acceptance of the revised Terms.</p>
        </Section>

        <Section title="2. Products and Pricing">
          <p>StoreOnline (operated by TS ELITE SOURCE LLC) offers a curated selection of compact electronics including drones, audio equipment, wearables, cameras, and smart gadgets. All product descriptions, images, and specifications are provided for informational purposes.</p>
          <p>Prices are displayed in US Dollars (USD) and are subject to change without notice. We reserve the right to limit quantities and to refuse or cancel orders at our sole discretion.</p>
          <p>There is no minimum order requirement. You may order any quantity of any product available on the Site, subject to stock availability.</p>
        </Section>

        <Section title="3. Orders and Payment">
          <p>By placing an order, you represent that you are of legal age and have the authority to enter into a binding agreement. All orders are subject to acceptance and availability.</p>
          <p>We accept major credit cards including Visa, Mastercard, American Express, and Discover. Payment must be received in full before your order is processed and shipped.</p>
          <p>Order confirmation emails will be sent to the email address provided during checkout. This confirmation represents our acceptance of your order.</p>
        </Section>

        <Section title="4. Shipping and Delivery">
          <p>StoreOnline ships to addresses within the United States and select international destinations. Shipping times are estimates and not guaranteed. Free standard shipping is available on orders over $99.</p>
          <p>Risk of loss and title for products pass to you upon delivery to the carrier. StoreOnline is not responsible for delays caused by the carrier or customs processing.</p>
          <p>Orders are typically processed within 1-3 business days. You will receive a tracking number via email once your order has shipped.</p>
        </Section>

        <Section title="5. Returns and Refunds">
          <p>We offer a 30-day return policy for most items in original, unused condition and original packaging. To initiate a return, contact our support team at info@e-storeonline.online.</p>
          <p>The following items are not eligible for return: opened software, items marked as final sale, and products with visible signs of use or damage caused by the customer.</p>
          <p>Refunds will be processed within 5-10 business days after we receive and inspect the returned item. Original shipping charges are non-refundable.</p>
        </Section>

        <Section title="6. Warranty">
          <p>All StoreOnline products come with a 1-year limited warranty against manufacturing defects. This warranty does not cover damage from misuse, accidents, unauthorized modifications, or normal wear and tear.</p>
          <p>To make a warranty claim, contact our support team with your order number and a description of the issue. We may require photos or the return of the defective product.</p>
        </Section>

        <Section title="7. Intellectual Property">
          <p>All content on this Site, including text, images, logos, and software, is the property of TS ELITE SOURCE LLC or its content suppliers and is protected by applicable copyright and intellectual property laws.</p>
          <p>You may not reproduce, distribute, or create derivative works from any content on this Site without our express written permission.</p>
        </Section>

        <Section title="8. Limitation of Liability">
          <p>To the maximum extent permitted by law, TS ELITE SOURCE LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of or inability to use our Site or products.</p>
          <p>Our total liability for any claim arising from these Terms or your purchase shall not exceed the amount you paid for the specific product giving rise to the claim.</p>
        </Section>

        <Section title="9. Governing Law">
          <p>These Terms shall be governed by and construed in accordance with the laws of the State of Georgia, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of Georgia.</p>
        </Section>

        <Section title="10. Contact Information">
          <p>For questions about these Terms, please contact us:</p>
          <p>
            <strong>TS ELITE SOURCE LLC</strong><br />
            5752 Keron Ln, Grovetown GA 30813<br />
            Email: legal@storeonline.online<br />
            Support: info@e-storeonline.online
          </p>
        </Section>
      </div>
    </motion.div>
  </div>
);

export default TermsPage;
